import React from "react"

const IntroductionText = () => (
  <div className='intro'>
    Hello, I am Carlos, a front-end developer specialized in ReactJs. <br />
    <br />
    With a passion for problem solving and design, my goal is to create websites
    and apps with{" "}
    <strong>
      a clean code, high quality UI and a compelling user experience
    </strong>
    .
    <br />
    <br />
    Because of my interest on the final-user and my design background,{" "}
    <strong>
      I can provide in-depth guidance, with an understanding of the feasibility
      of the tech side
    </strong>
    .
    <br />
    <br />
    Always looking to achieve more, I love participating in new projects, both
    professionally and personally.
    <br />
    Feel free to contact me as I'd love to hear about your project and engage in
    new challenges !
  </div>
)

export default IntroductionText
